module.exports = __webpack_public_path__ + "img/NA.8656bf49.png";